var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},_vm._l((_vm.links),function(link,index){return _c('asd20-button',{key:index,staticClass:"back",attrs:{"link":link.url,"target":"_self","label":link.label,"icon":"chevron","iconAngle":-90,"size":"md","horizontal":"","transparent":"","centered":"","reversed":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }